var map = {
	"./alert_error.png": "0b61",
	"./arrow-hint-navigation-left.png": "f888",
	"./arrow-hint-navigation-right.png": "f84c",
	"./arrow.png": "80bf",
	"./arrow_brown.png": "3c67",
	"./attempt-1.png": "1303",
	"./attempt-2.png": "cb0a",
	"./attempt-3.png": "6643",
	"./attempt-coin.png": "525e",
	"./attempt-wrong-score.png": "daac",
	"./attempt-wrong.png": "6e18",
	"./check-game-over.png": "288d",
	"./chronometer_bg.png": "1da4",
	"./circle-attempt-bg.png": "b17c",
	"./clock-skull.png": "678e",
	"./clock-timeout.png": "3d83",
	"./clock.png": "e6cd",
	"./coin-available.png": "66ca",
	"./coin-lock.png": "f366",
	"./coin.png": "bfb1",
	"./correct-extract-icon.png": "d708",
	"./enigma-1.png": "4cf9",
	"./enigma-2.png": "3ab0",
	"./enigma-3.png": "3fc0",
	"./enigma-4.png": "7d97",
	"./enigma-red-1.png": "314c",
	"./enigma-red-2.png": "38c3",
	"./enigma-red-3.png": "61b1",
	"./enigma-red-4.png": "7921",
	"./extract_hit_dark.png": "bfa2",
	"./extract_hit_light.png": "3124",
	"./extract_wrong.png": "6a53",
	"./failed-extract-icon.png": "7c99",
	"./feedback-checked.png": "a885",
	"./feedback-icon.png": "9700",
	"./feedback_correct.gif": "35df",
	"./feedback_correct_dark.png": "c5b4",
	"./feedback_correct_light.png": "edd1",
	"./feedback_game_over.gif": "3566",
	"./feedback_game_over_loop_dark.gif": "3039",
	"./feedback_game_over_loop_light.gif": "e00e",
	"./feedback_time_five_minutes.gif": "d393",
	"./feedback_time_five_minutes__.gif": "5e30",
	"./feedback_timeout.gif": "5eb8",
	"./feedback_timeout_dark.png": "c2b6",
	"./feedback_timeout_light.png": "0d0f",
	"./feedback_wrong.gif": "23d4",
	"./feedback_wrong_dark.png": "9c2d",
	"./feedback_wrong_discount_dark.gif": "32eb",
	"./feedback_wrong_discount_dark.png": "2399",
	"./feedback_wrong_discount_light.gif": "aafe",
	"./feedback_wrong_discount_light.png": "ec0d",
	"./feedback_wrong_light.png": "b74f",
	"./feedback_wrong_loop.gif": "8e90",
	"./gratidao.gif": "efa9",
	"./incorrect-extract-icon.png": "c821",
	"./joystick-with-bg.png": "63a9",
	"./joystick.png": "c80a",
	"./left-arrow-icon-light.png": "096d",
	"./left-arrow-icon.png": "1bca",
	"./lupa.png": "d009",
	"./plus.png": "6385",
	"./price-credit-icon.png": "fee5",
	"./price-credit-win-icon.png": "48fa",
	"./price-debit-icon.png": "5833",
	"./quizz_candidate.jpeg": "36d4",
	"./repense-icon.png": "9c76",
	"./report_arrow_left.png": "0bdb",
	"./report_arrow_left_active.png": "f7c9",
	"./report_arrow_right.png": "7985",
	"./report_arrow_right_active.png": "4fdb",
	"./right-arrow-icon-light.png": "ae04",
	"./right-arrow-icon.png": "c215",
	"./right-arrow.png": "a176",
	"./step-01.png": "3b4f",
	"./surrender.png": "d6ed",
	"./wrong-icon.png": "6f9b",
	"./xis-feedback-2.png": "cd23",
	"./xis-feedback.png": "746e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "643f";